import React from "react";
import DynamicTable2 from "../../components/DynamicTable2";
import { EmailInput, RadioButtonInput, PhoneNumberInput, CheckboxInput } from '../../components/FormInitiators';



const ArrearsSenventhForm1 = ({ formData, setFormData, onFormDataChange, onNext }) => {


  
  // Generic input handler
  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };
  
  const onTableDataChange = (key) => (rows) => {
    setFormData({ ...formData, [key]: rows });
  };




//////////////////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className='google_forms'>
      <div className="forms">
    <form className="seventh-pay-arrears-form">
      <h2>Information of Employee to Calculate Seventh Pay Arrears</h2>

      <label>
        Name of the Office:
        <input type="text" name="officeName" value={formData.officeName} onChange={handleInputChange} />
      </label>

      <label>
        Name of the Employee:
        <input type="text" name="employeeName" value={formData.employeeName} onChange={handleInputChange}/>
      </label>

      <label>
      <EmailInput
          value={formData.email}
          onChange={handleInputChange}
        />
      </label>

      <label>
      <PhoneNumberInput
        value={formData.phoneNumber}
        onChange={handleInputChange}
        name="phoneNumber"
      />
      </label>

      <label>
        Gender:
        <RadioButtonInput
          value={formData.gender} 
          onChange={handleInputChange}
          name="gender"  
          orientation="horizontal"  
          options={[
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' }
          ]}    
        />
      </label>

      <label>
        Designation:
        <input type="text"  name="designation" value={formData.designation}  onChange={handleInputChange}/>
      </label>

      <label>
        GPF/DCPS/NPS Account Number: (optional)
        <input type="text" name="accountNumber" value={formData.accountNumber} onChange={handleInputChange}/>
      </label>

      <label>
      Type of Account:
        <select name="accountType"  value={formData.accountType || ""} onChange={handleInputChange}>
          <option value="GPF">GPF</option>
          {/* <option value="DCPS">DCPS</option> */}
          {/* <option value="NPS">NPS</option> */}
        </select>
      </label>

      <label>
        Handicap:
        <RadioButtonInput
          value={formData.handicapped} 
          onChange={handleInputChange}
          name="handicapped"  
          orientation="horizontal"  
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' }
          ]}    
        />
      </label>

      <label>
      Professional Tax:
        <RadioButtonInput
          value={formData.professionalTax} 
          onChange={handleInputChange}
          name="professionalTax"  
          orientation="horizontal"  
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' }
          ]}    
        />
      </label>


      <label>
        <CheckboxInput
          value={formData.CLA}
          onChange={handleInputChange}
          name="CLA"
          label="CLA:"
        />
      </label>

      {formData.CLA && (
        <div>
         <DynamicTable2
        tableName="CLA Details:"
        columns={[
          {header: "Date", key: "date", name: "Date", type: "date", disableFirstRow: true },
          {header: "Amount", key: "amount", name: "Amount", type:"number" },
        ]}
        localStorageKey="CLADetails"
        onTableDataChange={onTableDataChange("CLADetails")}
        />
        </div>
        )}

      <label>
        Arrears Till Date:
        <div style={{ display: "flex", gap: "1rem" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
              <span>Start Date</span>
              <input type="date" name="arrearsStartDate" placeholder="Start Date" value={formData.arrearsStartDate || ""} onChange={handleInputChange}/>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
                <span>End Date</span>
                <input type="date" name="arrearsEndDate" placeholder="End Date" value={formData.arrearsEndDate || ""}  onChange={handleInputChange}/>
        </div>
        </div>
      </label>


      <div>
         <DynamicTable2
        tableName="Special Allowance Due:"
        columns={[
          {header: "Date", key: "date", name: "date", type: "date", disableFirstRow: true },
          {header: "Amount", key: "amount", name: "Amount", type:"number" },
        ]}
        localStorageKey="specialAllowanceDue"
        onTableDataChange={onTableDataChange("specialAllowanceDue")}
        />
      </div>      

      <div>
         <DynamicTable2
        tableName="Special Allowance Drawn:"
        columns={[
          {header: "Date", key: "date", name: "date", type: "date", disableFirstRow: true},
          {header: "Amount", key: "amount", name: "Amount", type:"number" },
        ]}
        localStorageKey="specialAllowanceDrawn"
        onTableDataChange={onTableDataChange("specialAllowanceDrawn")}
        />
      </div>    


     
      {/* Conditional button logic */}
      
        <button className="seventh-pay-arrears-buttons-container" type="button" onClick={onNext}>
          Next
        </button>
    </form>
    </div>
    </div>
  );
};

export default ArrearsSenventhForm1 ;